<script>

export default {
    name: "HomeAboutBlock",
}
</script>

<template>
    <div class="w-full bg-grayBg rounded-3xl text-black overflow-hidden">
        <div class="grid grid-cols-1 md:grid-cols-2 h-full md:min-h-[325px] divide-x">
            <div class="flex-1 flex flex-col order-2 md:order-1 p-5 md:p-10">
                <h1 class="flex flex-col gap-2 mb-[30px] text-2xl xl:text-3xl font-bold ">
                    <span>ООО «Дорожные Плиты»</span>
                    <span class="font-medium text-xl leading-tight">
                        Надёжный поставщик железобетонных изделий.
                    </span>
                </h1>
                <div class="flex flex-col gap-2 text-sm">
                    <p>
                        ООО «Дорожные Плиты» – это надежный поставщик железобетонных изделий. Компания специализируется
                        на производстве и продаже дорожных плит, используемых в строительстве дорог, промышленных
                        объектов, подъездных путей и временных площадок.
                    </p>
                    <p>
                        Мы предлагаем широкий ассортимент бетонных плит различных типоразмеров, соответствующих ГОСТ,
                        что гарантирует их долговечность и устойчивость к нагрузкам. Благодаря собственному производству
                        и налаженной логистике, мы обеспечиваем своевременные поставки по Москве и Московской области.
                    </p>
                    <p>
                        Мы сотрудничаем с строительными компаниями, промышленными предприятиями и
                        частными заказчиками, предоставляя качественные ЖБИ для различных строительных нужд. Мы работаем
                        с любыми объемами заказов, гарантируя надежность продукции и профессиональный подход к каждому
                        клиенту.
                    </p>
                </div>
            </div>
            <div class="order-1 md:order-2">
                <div class="w-full h-full grid grid-cols-3 divide-x divide-y">
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/9.webp" alt="Партнёр 9"
                             class="w-full p-2 max-h-[100px] md:max-h-[145px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/6.webp" alt="Партнёр 6"
                             class="w-full p-2 max-h-[100px] md:max-h-[145px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/5.webp" alt="Партнёр 5"
                             class="w-full p-2 max-h-[100px] md:max-h-[145px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/3.webp" alt="Партнёр 3"
                             class="w-full p-2 max-h-[100px] md:max-h-[145px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/4.webp" alt="Партнёр 4"
                             class="w-full p-2 max-h-[100px] md:max-h-[145px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/8.webp" alt="Партнёр 7"
                             class="w-full p-2 max-h-[100px] md:max-h-[145px] object-contain"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
